const btn = document.getElementById('header__btn');
const nav = document.getElementById('sp__nav');

btn.addEventListener('click', () => {
  btn.classList.toggle('is-active');
  nav.classList.toggle('is-active');
});

document.querySelectorAll('.sp__nav a').forEach(link => {
  link.addEventListener('click', () => {
    btn.classList.remove('is-active');
    nav.classList.remove('is-active');
  });
});
document.addEventListener("DOMContentLoaded", () => {
    const fadeInElements = document.querySelectorAll(".fade-in");

    const onScroll = () => {
        fadeInElements.forEach((el) => {
            const rect = el.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

            if (isVisible) {
                el.classList.add("show");
            }
        });
    };

    // スクロールイベントを監視
    window.addEventListener("scroll", onScroll);

    // ページ読み込み直後の状態も確認
    onScroll();
});





const fv__slider = new Swiper(".facility__slider", {
  slidesPerView: 1,
  loop: true,
  speed: 500,
  autoplay: {
    delay: 4000,              // 4秒ごとに切り替え
    disableOnInteraction: false // 操作後も自動再生を継続
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 5,
    },
  },
});

const initiatives__slider = new Swiper(".development__slider", {
  loop: true,
  slidesPerView: 1.2,
  speed: 10000, // 数値を大きくするとゆっくり流れる
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    allowTouchMove: false
  },
  freeMode: true,
  freeModeMomentum: false,
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
  },
});
